import { createTheme } from "@vividtheory/minerva-lab/theme";
export const theme = createTheme({
    palette: {
        //  ██████╗ ██████╗ ██╗      ██████╗ ██████╗ ███████╗
        // ██╔════╝██╔═══██╗██║     ██╔═══██╗██╔══██╗██╔════╝
        // ██║     ██║   ██║██║     ██║   ██║██████╔╝███████╗
        // ██║     ██║   ██║██║     ██║   ██║██╔══██╗╚════██║
        // ╚██████╗╚██████╔╝███████╗╚██████╔╝██║  ██║███████║
        //  ╚═════╝ ╚═════╝ ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝
        primary: {
            main: "#2F5AF0",
            onMain: "#FFFFFF",
            container: "#F6F8FF",
            onContainer: "#1C40C1",
        },
        secondary: {
            main: "#122159",
            onMain: "#FFFFFF",
            container: "#F6F8FF",
            onContainer: "#03082A",
        },
        surface: {
            main: "#1E1E1E",
            onMain: "#FFFFFF",
            container: "#F6F7FB",
            onContainer: "#171A1D",
        },
        success: {
            main: "#12B76A",
            onMain: "#FFFFFF",
            container: "#ECFDF3",
            onContainer: "#053321",
        },
        info: {
            main: "#1570EF",
            onMain: "#FFFFFF",
            container: "#EFF8FF",
            onContainer: "#102A56",
        },
        warning: {
            main: "#F79009",
            onMain: "#FFFFFF",
            container: "#FFFAEB",
            onContainer: "#4E1D09",
        },
        error: {
            main: "#F04438",
            onMain: "#FFFFFF",
            container: "#FEF3F2",
            onContainer: "#55160C",
        },
        disabled: {
            main: "#D0D5DD",
            onMain: "#FFFFFF",
            container: "#F4F5F4",
            onContainer: "#787884",
        },
        background: {
            main: "#FFFFFF",
            onMain: "#14161D",
            container: "#FCFCFD",
            onContainer: "#060B0B",
        },
        outline: "#E0E0E0",
        stroke: {
            50: "#F9FAFB",
            100: "#F2F4F7",
            200: "#E4E7EC",
            300: "#D0D5DD",
        },
    },
    // ████████╗██╗   ██╗██████╗  ██████╗  ██████╗ ██████╗  █████╗ ██████╗ ██╗  ██╗██╗   ██╗
    // ╚══██╔══╝╚██╗ ██╔╝██╔══██╗██╔═══██╗██╔════╝ ██╔══██╗██╔══██╗██╔══██╗██║  ██║╚██╗ ██╔╝
    //    ██║    ╚████╔╝ ██████╔╝██║   ██║██║  ███╗██████╔╝███████║██████╔╝███████║ ╚████╔╝
    //    ██║     ╚██╔╝  ██╔═══╝ ██║   ██║██║   ██║██╔══██╗██╔══██║██╔═══╝ ██╔══██║  ╚██╔╝
    //    ██║      ██║   ██║     ╚██████╔╝╚██████╔╝██║  ██║██║  ██║██║     ██║  ██║   ██║
    //    ╚═╝      ╚═╝   ╚═╝      ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝     ╚═╝  ╚═╝   ╚═╝
    typography: {
        h: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "4rem", // 64px / 16px
        },
        h1: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "3.25rem", // 52px / 16px
        },
        h2: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "2.625rem", // 42px / 16px
        },
        h3: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "2rem", // 32px / 16px
        },
        h4: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1.75rem", // 28px / 16px
        },
        h5: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1.5rem", // 24px / 16px
        },
        h6: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1.25rem", // 20px / 16px
        },
        title1: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1.125rem", // 18px / 16px
        },
        title2: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1rem", // 16px / 16px
        },
        title3: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "0.875rem", // 14px / 16px
        },
        title4: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "0.75rem", // 12px / 16px
        },
        body: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1.5rem", // 24px / 16px
        },
        body1: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1.125rem", // 18px / 16px
        },
        body2: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1rem", // 16px / 16px
        },
        body3: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "0.875rem", // 14px / 16px
        },
        body4: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "0.75rem", // 12px / 16px
        },
        button: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "0.875rem", // 14px / 16px
        },
        textFieldLabel: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "0.875rem", // 14px / 16px
        },
        textFieldBody: {
            fontFamily: '"Outfit", sans-serif',
            fontSize: "1rem", // 16px / 16px
        },
        fontWeightRegular: 400,
        fontWeightSemiBold: 500,
        fontWeightBold: 700,
    },
    // ██████╗ ███████╗███████╗ █████╗ ██╗   ██╗██╗  ████████╗██████╗ ██████╗  ██████╗ ██████╗ ███████╗
    // ██╔══██╗██╔════╝██╔════╝██╔══██╗██║   ██║██║  ╚══██╔══╝██╔══██╗██╔══██╗██╔═══██╗██╔══██╗██╔════╝
    // ██║  ██║█████╗  █████╗  ███████║██║   ██║██║     ██║   ██████╔╝██████╔╝██║   ██║██████╔╝███████╗
    // ██║  ██║██╔══╝  ██╔══╝  ██╔══██║██║   ██║██║     ██║   ██╔═══╝ ██╔══██╗██║   ██║██╔═══╝ ╚════██║
    // ██████╔╝███████╗██║     ██║  ██║╚██████╔╝███████╗██║   ██║     ██║  ██║╚██████╔╝██║     ███████║
    // ╚═════╝ ╚══════╝╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚═╝     ╚══════╝
    defaultProps: {
        Accordion: {
            disableHoverEffect: true,
            disableActiveEffect: true,
        },
        Tooltip: {
            color: "background",
        },
        Button: {
            density: "dense",
        },
        IconButton: {
            density: "dense",
        },
        NavigationRailIcon: {
            density: "dense",
        },
        Svg: {
            size: "sm",
        },
        ThumbnailAvatar: {
            color: "surface",
        },
        CompanyAvatar: {
            color: "surface",
        },
        IconAvatar: { color: "surface" },
        UserAvatar: { color: "surface" },
        Divider: {
            color: 100,
        },
        TabGroup: {
            density: "dense",
        },
    },
});
//# sourceMappingURL=theme.js.map